module.exports = __webpack_public_path__ + "img/CM-MR-CA-Mazda-Lifestyle.086d50a0.jpeg";